import { t } from "@travily/i18n";
import { OutlineButton } from "@ui/components/OutlineButton";
import { useInfiniteScrollTrigger } from "@ui/hooks/use-infinite-scroll-trigger";

export interface LoadMoreTriggerProps {
  hasMore: boolean;
  isLoading?: boolean;
  onLoadMore: () => void;
}

export function LoadMoreTrigger({ hasMore, isLoading = false, onLoadMore }: LoadMoreTriggerProps) {
  const { ref, requestLoadMore } = useInfiniteScrollTrigger<HTMLDivElement>({
    hasMore,
    isLoading,
    onLoadMore,
  });

  if (!hasMore) return null;

  return (
    <div className="flex justify-center" ref={ref}>
      <OutlineButton isPending={isLoading} onPress={requestLoadMore}>
        {t("common.actions.view_more")}
      </OutlineButton>
    </div>
  );
}
